export default "__VITE_ASSET__Bb7zyRFr__"